import { Navigate, useParams } from "react-router-dom";

/** /blog/:slug → /:slug (canonical article URL). */
export default function BlogLegacyRedirect() {
  const { slug } = useParams();
  if (!slug) return <Navigate to="/blog" replace />;
  return <Navigate to={`/${slug}`} replace />;
}
